var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedgerDetailBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4391 8.01381C16.6439 8.65604 16.7497 9.32576 16.7527 9.99988C16.7527 13.7294 13.7294 16.7527 9.99988 16.7527C6.27041 16.7527 3.24707 13.7294 3.24707 9.99988C3.24707 6.27041 6.27041 3.24707 9.99988 3.24707C10.674 3.25007 11.3437 3.35583 11.986 3.5607",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7525 4.20312L15.2608 5.69475L14.3042 4.7381",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1251 11.8752C9.67477 11.8752 8.49902 10.6995 8.49902 9.24914C8.49902 7.79879 9.67477 6.62305 11.1251 6.62305C12.5755 6.62305 13.7512 7.79879 13.7512 9.24914C13.7512 10.6995 12.5755 11.8752 11.1251 11.8752",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74685 8.1377C7.46396 8.19778 6.41362 9.17867 6.26605 10.4545C6.11847 11.7303 6.91715 12.925 8.15244 13.2764C9.38773 13.6278 10.6957 13.0322 11.2416 11.8698",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerDetailBalanceIcon);
export default __webpack_public_path__ + "static/media/ledger-detail-balance-icon.f80498bf4ce58c0f73df4246c6046153.svg";
export { ForwardRef as ReactComponent };